import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SharedModule } from 'src/app/shared/shared.module';
import { PageSubComponent } from './components/page-sub/page-sub.component';
import { PageComponent } from './components/page/page.component';
import { PageRoutingModule } from './page-routing.module';
import { PolicyComponent } from './components/policy/policy.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';

@NgModule({
  declarations: [PageComponent, PageSubComponent, PolicyComponent, SitemapComponent],
  imports: [CommonModule, PageRoutingModule, SharedModule, LazyLoadImageModule],
})
export class PageModule {}
